import React, { Component } from "react";

export default class Model extends Component {
  constructor(props) {
    super(props);
    this.state = {};


  }

  componentDidMount(){
 
  }

  componentDidUpdate(prevProps){
      if(prevProps.activeModel !== this.props.activeModel){
   }
  }

modelSelected(model){
  this.props.modelSelected(model);

}

  render() {
    const { hasModels } = this.props;
    return (
      <div onClick={() => this.modelSelected(this.props.model)} className={`model ${hasModels ? "model--active" : "model--deactive"} ${this.props.activeModel === this.props.model ? "model--selected": ""}`}>
        <div className="model--name">
          <img className="icon" src="./assets/images/arrow.svg" alt="arrow" />
          {this.props.name}
        </div>
        <div className="model--image">
          <img
            src={`./assets/images/${this.props.image}`}
            alt={this.props.name}
          />
        </div>
      </div>
    );
  }
}
